import { createBrowserHistory } from "history";

var history = () => {
  return createBrowserHistory({ basename: "install" });
};

export default history();
